<template>
	<!-- BEGIN register -->
	<div class="register register-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image">
				<img src="./../images/foundpass.jpg" alt="" style="width: 100%;height: 100%;">
			</div>
			<div class="news-caption">
				<h4 class="caption-title">湖南高铁时代综合实训管理平台</h4>

			</div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN register-container -->
		<div class="register-container" style="padding: 55px;">
			<!-- BEGIN register-header -->
			<div class="register-header mb-25px h1">
				<div class="mb-1">忘记密码</div>
				<small class="d-block fs-15px lh-16" v-if="scssucsemian==0">通过邮箱地址修改原来的密码</small>
				<small class="d-block fs-15px lh-16" v-if="scssucsemian==1">请修改密码</small>
			</div>
			<!-- END register-header -->

			<!-- BEGIN register-content -->
			<div class="register-content">
				<form class="fs-13px" v-if="scssucsemian==0">
					<div class="mb-3">
						<label class="mb-2">邮箱地址 <span class="text-danger">*</span><span class="mb-2"
								style="color: red;margin-left: 0.5rem;display: inline;"
								v-if="usershow==4">请输入邮箱或者邮箱输入错误</span></label>
						<div class="emaila">
							<input @change="changeemian()" @blur="changeemian" v-model="users.Emai" type="text"
								:style="{'border-color':usershow==4?'red':''}" class="form-control fs-13px"
								placeholder="请输入邮箱地址" />
						</div>
					</div>
				</form>

				<form class="fs-13px" v-if="scssucsemian==1">
					<div class="mb-3">
						<label class="mb-2">邮箱地址 <span class="text-danger">*</span></label>
						<!-- <div class="emaila">
							<input v-model="" type="text" class="form-control fs-13px"
								:style="{'border-color':usershow==4?'red':''}" placeholder="请输入邮箱地址" />
						</div> -->
						<p>{{users.Emai}}</p>
					</div>
					<div class="mb-4">
						<label class="mb-2">新的密码 <span class="text-danger">*</span><span class="mb-2"
								style="color: #B0171F;margin-left: 0.5rem;display: inline;"
								v-show="usertextshow==2 ">请输入8-16位的密码,必须是字母与数字</span></label>
						<input @input="changetext(2)" style="color: #000;" v-model="users.password" type="password"
							:style="{'border-color':usertextshow==2?'red':''}" class="form-control fs-13px"
							placeholder="请输入新的密码" />
					</div>
					<div class="mb-4">
						<label class="mb-2">再次输入密码 <span class="text-danger">*</span>
							<span class="mb-2" style="color: red;margin-left: 0.5rem;display: inline;"
								v-show="usershow==3">请输入相同密码</span>
						</label>
						<input @input="changetext(3)" style="color: #000;" v-model="users.passwordtoo" type="password"
							:style="{'border-color':usershow==3?'red':''}" class="form-control fs-13px"
							placeholder="请再次输入密码" />

					</div>
					<div class="mb-4">
						<label class="mb-2">验证码 <span class="text-danger">*</span>
							<span class="mb-2" style="color: #ccc;margin-left: 0.5rem;display: inline;"
								v-show="usershow == 6">请输入正确的验证码</span>
						</label>
						<div class="col-md-8 mb-2 mb-md-0">
							<input v-model="users.identifying" style="color: #000;" type="text"
								:style="{'border-color':usershow==6?'red':''}" class="form-control fs-13px"
								placeholder="请输入验证码" />
						</div>

					</div>

				</form>



				<div class="mb-4">
					<button type="button" class="btn btn-primary d-block w-100 btn-lg h-45px fs-13px"
						@click="registers()" v-if="scssucsemian==0" v-preventReClick>发送邮件</button>

					<button type="button" class="btn btn-primary d-block w-100 btn-lg h-45px fs-13px"
						@click="changepassword()" v-if="scssucsemian==1" v-preventReClick>修改密码</button>
				</div>
				<div class="mb-4 pb-5" style="width: 100%;text-align: right;">
					已有帐号? <router-link to="/user/logins" >马上登陆</router-link>
				</div>
				<hr class="bg-gray-600 opacity-2" />
				<p class="text-center text-gray-600">
					&copy; 实训后台管理系统 2022
				</p>
			</div>
		</div>
	</div>
</template>



<script>
	import AppOptions from '../config/AppOptions.vue'
	import {
		IndexSendEmail,
		IndexEditPassWord
	} from "@/request/alllog.js"


	export default {
		data() {
			return {
				// 判断邮件发送成功
				scssucsemian: 0,

				// 判断是否存在
				foundems: 0,
				// 注册用户
				users: {
					username: "",
					password: "",
					passwordtoo: "",
					Emai: "",
					identifying: "",
				},
				// 控制提示符
				usershow: 0,
				usertextshow: 0,
				// 用户协议
				checkuser: false

			}
		},
		created() {
			AppOptions.appEmpty = true;

		},
		updated() {

		},
		beforeRouteLeave(to, from, next) {
			AppOptions.appEmpty = false;
			next();
		},
		methods: {
			changeemian() {
				var emailRegExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; //验证邮箱的正则表达式
				var ok = emailRegExp.test(this.users.Emai); //验证是否符合要求
				if (ok) {
					this.usershow = 0
				} else {
					this.usershow = 4
				}
			},


			changepassword() {

				if (this.users.Emai.length == 0) {
					this.usershow = 4
				} else if (this.users.password.length == 0) {
					this.usertextshow = 2
				} else if (this.users.passwordtoo != this.users.password || this.users.passwordtoo.length == 0) {
					this.usershow = 3
				} else if (this.users.identifying.length == 0) {
					this.usershow = 6
				} else {
					let changepsd = {
						email: this.users.Emai,
						ecode: this.users.identifying,
						newpassword1: this.users.password,
						newpassword2: this.users.passwordtoo
					}
					IndexEditPassWord(changepsd).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: res.data.msg + "3秒后跳转登录页面",
								type: 'success'
							});
							this.users.identifying = ""
							this.users.password = ""
							this.users.passwordtoo = ""
							let that = this
							setTimeout(() => {
								that.$router.push({
									path: "/user/logins"
								})
							}, 3000)
						} else {
							this.$message(res.data.msg)
						}
					})




				}
			},

			// 当input聚焦是显示对应的值
			changetext(i) {
				let pas = this.users.password
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
				var re = new RegExp(reg)
				if (i == 2) {
					// console.log("到密码了")
					this.usershow = 0
					if (pas.length > 0 && pas.length <= 8) {
						// console.log("进入不满足条件")
						// console.log(re.test(pas))
						this.usertextshow = 2

					} else if (pas.length > 8) {
						// console.log("进入满足条件")
						if (re.test(pas)) {
							// console.log(pas)
							this.usertextshow = 0
						}
					}
				}

				if (i == 3) {
					if (pas == this.users.passwordtoo) {
						this.usershow = 0
						// console.log("到等于状态")
					} else {
						this.usershow = 3
						// console.log("到不等于状态")
					}
				}




			},
			// 失去焦点判断是否存在
			foundpas() {
				console.log("开始失去焦点")
				let changeedata = this.users.Emai
				changeemial(changeedata).then(res => {
					console.log(res)
					if (res.data.code == -1) {
						this.foundems = 2
					} else {
						this.foundems = 1
					}
				})
			},

			// 立即注册
			registers() {
				if (this.users.Emai.length == 0) {
					this.usershow = 4
				} else {
					let useremain = {
						email: this.users.Emai
					}

					IndexSendEmail(useremain).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
							this.scssucsemian = 1

						} else {
							this.$message(res.data.msg)
						}
					})



				}

			},
			// 当input聚焦是显示对应的值
			changetext(i) {
				// console.log(i)
				let pas = this.users.password
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
				var re = new RegExp(reg)
				if (i == 1) {
					if (this.users.username.length > 0 && '' + this.users.username.length < 4) {
						this.usershow = 1
					} else if ('' + this.users.username.length > 4) {
						this.usershow = 0
					}

				}
				if (i == 2) {
					// console.log("到密码了")
					this.usershow = 0

					if (pas.length > 0 && pas.length <= 8) {
						// console.log("进入不满足条件")
						// console.log(re.test(pas))
						this.usertextshow = 2

					} else if (pas.length > 8) {
						// console.log("进入满足条件")
						if (re.test(pas)) {
							// console.log(pas)
							this.usertextshow = 0
						}
					}
				}

				if (i == 3) {
					if (pas == this.users.passwordtoo) {
						this.usershow = 0
						// console.log("到等于状态")
					} else {
						this.usershow = 3
						// console.log("到不等于状态")
					}
				}


				//邮箱
				if (i == 4) {
					var rege = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
					var resm = new RegExp(rege)
					if (resm.test(this.users.Emai)) {
						this.usershow = 0
						// console.log(resm.test(this.users.Emai))
					} else {
						this.usershow = 4
						// console.log(resm.test(this.users.Emai))
					}
				}


			},
			// // 注册的一些判定值
			// reject() {
			// 	// console.log(pas.length)

			// },
		}
	}
</script>



<style scoped lang="less">
	.emaila {
		display: flex;
		align-items: center;

		span {
			margin: 0 10px;
			font-size: 1rem;
		}

		span.el-icon-error {
			color: red;
		}

		span.el-icon-success {
			color: green;
		}

	}

	.registerselect option {
		color: #ccc;
	}

	.sleted {
		outline: 0 #ced4da;
		display: block;
		width: 100%;
		padding: 0.4375rem 0.75rem;
		font-size: 0.75rem;
		font-weight: 600;
		line-height: 1.5;
		/* color: var(--app-component-color); */
		color: #747474;
		background-color: var(--app-component-bg);
		background-clip: padding-box;
		border: 1px solid #ced4da;
	}
</style>
